export default __webpack_public_path__ + "static/media/customers-api-usage.1fe111bb.svg";